import React, { useEffect, useRef, useState } from "react";
import { Box, Button, Card, Tabs, TextField, Typography } from "@mui/material";
import Loader from "../../helpers/constants/Loader";
import { showError, showToast } from "../../constants/toasts";
import WarnModal from "../../Modals/WarnModal";
// import { displayManageText } from "../../constants/permission";
import {
  useLazyGetFAQQuery,
  useLazyGetFAQByIdQuery,
  useAddFAQMutation,
  useUpdateFAQByIdMutation,
  useDeleteFAQByIdMutation,
} from "../../services/faq";
// import { Pagination } from "../../components";
import SearchBar from "../../components/SearchBar";
import { isValidInput } from "../../utils/validations";
import MainContainer from "../../layout/MainContainer";

const ManageFaq = () => {
  const ref: any = useRef(null);

  const [value, setValue] = React.useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<string>("");
  const [newAnswer, setNewAnswer] = useState("");
  const [newQuestion, setNewQuestion] = useState("");
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState<number>(0);
  const totalPages = Math.ceil(totalCount / 10);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const onPageChange = (newPage: number) => {
    setPage?.(newPage);
  };
  const [faq, setFaq] = useState<any>([
    {
      question: "this is question",
      answer: "This is answer to above question",
    },
  ]);

  const [addData] = useAddFAQMutation();
  const [getAllData] = useLazyGetFAQQuery();
  const [deleteById] = useDeleteFAQByIdMutation();
  const [updateData]: any = useUpdateFAQByIdMutation();

  const getFaqList: any = async () => {
    ref?.current?.continuousStart();

    setIsLoading(true);
    try {
      const response = await getAllData({
        limit: 10,
        page: page,
        search: debouncedSearchTerm,
      }).unwrap();
      if (response?.statusCode === 200) {
        setFaq(response?.data?.data);
        setTotalCount(response?.data?.totalCount);
      } else {
        setFaq([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
    setIsLoading(false);
    ref?.current?.complete();
  };
  const addFaq: any = async () => {
    setIsLoading(true);
    try {
      const body = {
        question: newQuestion,
        answer: newAnswer,
      };
      const response = await addData(body).unwrap();
      if (response?.statusCode === 200) {
        setNewQuestion("");
        setNewAnswer("");
        showToast("FAQ added successfully");
        getFaqList();
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
    setIsLoading(false);
  };
  const updateFaq = async (index: any) => {
    if (faq[index].question.replaceAll("\n", "").trim() == "") {
      showError("Faq question is required");
      return;
    }
    if (faq[index].answer.replaceAll("\n", "").trim() == "") {
      showError("Faq answer is required");
      return;
    }
    setIsLoading(true);
    try {
      const body = {
        question: faq[index].question,
        answer: faq[index].answer,
      };
      const response = await updateData({
        id: faq[index]._id,
        body: body,
      }).unwrap();
      if (response?.statusCode === 200) {
        showToast("FAQ updated successfully");

        getFaqList();
      } else {
        setFaq([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
    setIsLoading(false);
  };

  const removeFaq = async (id: string) => {
    setIsLoading(true);
    try {
      await deleteById({ id });
      setFaq((prevFaq: any[]) => prevFaq.filter((item) => item._id !== id));
      showToast("FAQ removed successfully");
      getFaqList();
    } catch (error: any) {
      showError(error?.data?.message || "Failed to remove FAQ");
    }
    setOpen(false);
    setIsLoading(false);
  };

  useEffect(() => {
    getFaqList();
  }, [page, debouncedSearchTerm]);

  return (
    <>
      <MainContainer>
        <div className="main_loyout">
          {/* <Loader isLoad={isLoading} /> */}

          <div className="dashboard">
            <h1 className="mn_hdng">
              {/* {displayManageText ? "Manage FAQs" : "FAQs"} */}
              {/* <p style={{ marginTop: 4 }}>Total FAQs : {totalCount ? totalCount : '0'} </p> */}
              Manage FAQs
            </h1>
          </div>
          <Box className="cards_header">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
              placeholder={""}
            />
            <Box className="cards_header_right">
              {/* Removed ExportButton */}
            </Box>
          </Box>
          {
            <Card className="cards">
              <Typography className="custom_label" style={{ fontSize: "15px" }}>
                Add New FAQ
              </Typography>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  addFaq();
                }}
              >
                <Box>
                  <div style={{ marginBottom: "10px", marginTop: "10px" }}>
                    <Typography className="custom_label">Question</Typography>
                    <TextField
                      hiddenLabel
                      fullWidth
                      value={newQuestion}
                      className="text_field"
                      multiline
                      minRows={1}
                      maxRows={3}
                      onChange={(e) => {
                        if (e.target.value == " ") {
                          return;
                        }

                        if (e.target.value.length <= 500) {
                          setNewQuestion(e.target.value);
                        } else {
                          showError("Question can't exceed 500 characters");
                        }
                      }}
                      placeholder="Enter Question"
                    />
                  </div>
                  <div style={{ marginBottom: "10px" }}>
                    <Typography className="custom_label">Answer</Typography>
                    <TextField
                      fullWidth
                      hiddenLabel
                      className="text_field"
                      multiline
                      minRows={1}
                      maxRows={3}
                      value={newAnswer}
                      onChange={(e) => {
                        if (e.target.value == " ") {
                          return;
                        }

                        if (e.target.value.length <= 500) {
                          setNewAnswer(e.target.value);
                        } else {
                          showError("Answer can't exceed 500 characters");
                        }
                      }}
                      placeholder="Enter Answer"
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      padding: "10px",
                      paddingBottom: "5px",
                    }}
                  >
                    <Button
                      className="btn btn_primary"
                      type="submit"
                      disabled={!(newQuestion.length && newAnswer.length)}
                    >
                      Add
                    </Button>
                  </div>
                </Box>
              </form>
            </Card>
          }
          <div style={{ backgroundColor: "transparent", marginTop: "10px" }}>
            {faq?.map((data: any, mainIndex: number) => {
              return (
                <div
                  // sx={{
                  //   mb: 2,
                  // }}
                  style={{
                    marginBottom: 12,
                  }}
                  className="cards"
                >
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      updateFaq(mainIndex);
                    }}
                  >
                    <div>
                      <div style={{ marginBottom: "10px", marginTop: "10px" }}>
                        <Typography className="custom_label">
                          Question
                        </Typography>
                        <TextField
                          value={data?.question}
                          onChange={(e) => {
                            if (e.target.value == " ") {
                              return;
                            }
                            if (e.target.value.length <= 500) {
                              setFaq((prevData: any) => {
                                return prevData.map(
                                  (item: any, index: number) => {
                                    if (mainIndex == index) {
                                      return {
                                        ...item,
                                        question: e.target.value,
                                      };
                                    }
                                    return item;
                                  }
                                );
                              });
                            } else {
                              showError("Question can't exceed 500 characters");
                            }
                          }}
                          hiddenLabel
                          fullWidth
                          className="text_field"
                          multiline
                          minRows={1}
                          maxRows={3}
                          placeholder={"Question " + (mainIndex + 1)}
                          name="question1"
                        />
                      </div>
                      <div style={{ marginBottom: "10px" }}>
                        <Typography className="custom_label">Answer</Typography>
                        <TextField
                          fullWidth
                          hiddenLabel
                          className="text_field"
                          multiline
                          minRows={1}
                          maxRows={3}
                          value={data?.answer}
                          onChange={(e) => {
                            if (e.target.value == " ") {
                              return;
                            }

                            if (e.target.value.length <= 500) {
                              setFaq((prevData: any) => {
                                return prevData.map(
                                  (item: any, index: number) => {
                                    if (mainIndex == index) {
                                      return {
                                        ...item,
                                        answer: e.target.value,
                                      };
                                    }
                                    return item;
                                  }
                                );
                              });
                            } else {
                              showError("Answer can't exceed 500 characters");
                            }
                          }}
                          placeholder={"Answer " + (mainIndex + 1)}
                          name="answer1"
                        />
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "end",
                          padding: "10px",
                          paddingBottom: "5px",
                        }}
                      >
                        {
                          <Button
                            type="submit"
                            style={{ marginInline: "4px" }}
                            className="btn btn_primary"
                          >
                            Update
                          </Button>
                        }
                        {
                          <Button
                            onClick={() => {
                              setSelectedId(data?._id);
                              setOpen(true);
                            }}
                            className="btn btn_primary"
                          >
                            Remove
                          </Button>
                        }
                      </div>
                    </div>
                  </form>
                </div>
              );
            })}
          </div>
        </div>

        <WarnModal
          setOpen={setOpen}
          open={open}
          name={"FAQ"}
          handleDelete={() => {
            removeFaq(selectedId);
          }}
        />
      </MainContainer>
    </>
  );
};

export default ManageFaq;
